/* PMSTEEL · Mini-cart dropdown (header cart icon).
   Amazon-style: hover (desktop) or click opens a panel with the cart contents,
   subtotal, and View cart / Checkout buttons — the icon itself never navigates
   while the panel is enabled (no-JS falls back to the plain /cart link).
   Contents are fetched fresh from /cart.js on every open; a cart-update
   subscription refreshes the panel if it's open when something is added. */
(function () {
  var wrap = document.querySelector('[data-pmsteel-mc]');
  if (!wrap) return;

  var icon = wrap.querySelector('#cart-icon-bubble');
  var panel = wrap.querySelector('[data-pmsteel-mc-panel]');
  var itemsEl = wrap.querySelector('[data-pmsteel-mc-items]');
  var subtotalEl = wrap.querySelector('[data-pmsteel-mc-subtotal]');
  var statusEl = wrap.querySelector('[data-pmsteel-mc-status]');
  if (!icon || !panel) return;

  var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var closeTimer = null;
  var open = false;

  icon.setAttribute('aria-haspopup', 'dialog');
  icon.setAttribute('aria-expanded', 'false');
  if (panel.id) icon.setAttribute('aria-controls', panel.id);

  function announce(message) {
    if (statusEl) statusEl.textContent = message || '';
  }

  function safeError(data) {
    if (data && typeof data.description === 'string' && data.description.trim()) return data.description;
    if (data && typeof data.message === 'string' && data.message.trim()) return data.message;
    return panel.getAttribute('data-error-message') || 'Unable to update cart. Please try again.';
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function escAttr(s) {
    return esc(s).replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function render(cart, requireSection) {
    if (requireSection && !updateHeaderFromSection(cart)) {
      window.location.reload();
      return false;
    }
    if (!cart || !cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '<p class="pmsteel-mc__empty">Your cart is empty.</p>';
      if (subtotalEl) subtotalEl.textContent = money(0, cart && cart.currency);
      return true;
    }
    var html = cart.items.map(function (it) {
      var img = it.image
        ? '<img class="pmsteel-mc__img" src="' + it.image.replace(/(\.[a-z]{3,4})(\?|$)/i, '_96x96$1$2') + '" alt="" width="48" height="48" loading="lazy">'
        : '<span class="pmsteel-mc__img pmsteel-mc__img--ph"></span>';
      var variant = it.variant_title && it.variant_title !== 'Default Title'
        ? '<span class="pmsteel-mc__variant">' + esc(it.variant_title) + '</span>' : '';
      var itemName = escAttr(it.product_title) + (it.variant_title && it.variant_title !== 'Default Title' ? ' – ' + escAttr(it.variant_title) : '');
      return '<div class="pmsteel-mc__item" data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '">' +
        '<a class="pmsteel-mc__imglink" href="' + esc(it.url) + '" tabindex="-1">' + img + '</a>' +
        '<span class="pmsteel-mc__meta"><a class="pmsteel-mc__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
        '<span class="pmsteel-mc__stepper">' +
          '<button type="button" class="pmsteel-mc__qbtn" data-mc-minus aria-label="Decrease quantity for ' + itemName + '">&minus;</button>' +
          '<span class="pmsteel-mc__q">' + it.quantity + '</span>' +
          '<button type="button" class="pmsteel-mc__qbtn" data-mc-plus aria-label="Increase quantity for ' + itemName + '">&plus;</button>' +
          '<button type="button" class="pmsteel-mc__remove" data-mc-remove aria-label="Remove ' + itemName + ' from cart">Remove</button>' +
        '</span></span>' +
        '<span class="pmsteel-mc__price">' + money(it.final_line_price, cart.currency) + '</span></div>';
    }).join('');
    itemsEl.innerHTML = html;
    if (subtotalEl) subtotalEl.textContent = money(cart.items_subtotal_price, cart.currency);
    return true;
  }

  function updateHeaderFromSection(cart) {
    var section = cart && cart.sections && cart.sections['cart-icon-bubble'];
    if (typeof section !== 'string') return false;
    var source = new DOMParser().parseFromString(section, 'text/html').querySelector('#shopify-section-cart-icon-bubble');
    var marker = source && source.querySelector('[data-pmsteel-cart-count]');
    if (!marker || Number(marker.getAttribute('data-pmsteel-cart-count')) !== Number(cart.item_count)) return false;
    icon.innerHTML = source.innerHTML;
    return true;
  }

  /* quantity changes / removal via the Cart API */
  var changing = false;
  var refocus = null;
  function focusAfterRender() {
    if (!refocus) return;
    var target = null;
    var row = itemsEl.querySelector('[data-key="' + CSS.escape(refocus.key) + '"]');
    if (row && !refocus.removed) target = row.querySelector(refocus.sel);
    if (!target && refocus.removed) {
      var rows = Array.prototype.slice.call(itemsEl.querySelectorAll('[data-key]'));
      var nextRow = rows[Math.min(refocus.index, Math.max(0, rows.length - 1))];
      if (nextRow) target = nextRow.querySelector('[data-mc-plus], [data-mc-minus], [data-mc-remove], .pmsteel-mc__title');
    }
    (target || icon).focus();
  }

  function changeLine(key, quantity) {
    if (changing) return;
    changing = true;
    announce('');
    itemsEl.setAttribute('aria-busy', 'true');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        sections: ['cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (data) { return { ok: response.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          var responseError = new Error('Cart update failed');
          responseError.data = result.data;
          throw responseError;
        }
        var cart = result.data;
        if (!render(cart, true)) return;
        if (refocus) {
          var updated = cart.items && cart.items.find(function (item) { return item.key === refocus.key; });
          var finalQuantity = updated ? updated.quantity : 0;
          announce(finalQuantity > 0
            ? refocus.name + ' quantity updated to ' + finalQuantity + '.'
            : refocus.name + ' removed from cart.');
          focusAfterRender();
          refocus = null;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pmsteel-mini-cart', cartData: cart });
        }
      })
      .catch(function (error) {
        announce(safeError(error && error.data));
        if (refocus && refocus.control) refocus.control.focus();
        refocus = null;
      })
      .finally(function () {
        changing = false;
        itemsEl.removeAttribute('aria-busy');
      });
  }

  itemsEl.addEventListener('click', function (e) {
    var row = e.target.closest('[data-key]');
    if (!row) return;
    var key = row.getAttribute('data-key');
    var qty = parseInt(row.getAttribute('data-qty'), 10) || 0;
    var rows = Array.prototype.slice.call(itemsEl.querySelectorAll('[data-key]'));
    var nameEl = row.querySelector('.pmsteel-mc__title');
    var name = nameEl && nameEl.textContent.trim() || 'Item';
    var control = e.target.closest('[data-mc-plus], [data-mc-minus], [data-mc-remove]');
    if (e.target.closest('[data-mc-plus]')) {
      refocus = { key: key, sel: '[data-mc-plus]', name: name, index: rows.indexOf(row), removed: false, control: control };
      changeLine(key, qty + 1);
    } else if (e.target.closest('[data-mc-minus]')) {
      var nextQuantity = Math.max(0, qty - 1);
      refocus = { key: key, sel: '[data-mc-minus]', name: name, index: rows.indexOf(row), removed: nextQuantity === 0, control: control };
      changeLine(key, nextQuantity);
    } else if (e.target.closest('[data-mc-remove]')) {
      refocus = { key: key, sel: '[data-mc-remove]', name: name, index: rows.indexOf(row), removed: true, control: control };
      changeLine(key, 0);
    }
  });

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json().then(function (data) { return { ok: response.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok || result.data.status) throw result.data;
        render(result.data, false);
      })
      .catch(function (error) { announce(safeError(error)); });
  }

  /* phones: the icon-anchored panel would run off the left edge — pin it to the
     viewport, full width under the (sticky) header, instead */
  function place() {
    if (window.matchMedia('(max-width: 749px)').matches) {
      var r = icon.getBoundingClientRect();
      panel.style.position = 'fixed';
      panel.style.left = '8px';
      panel.style.right = '8px';
      panel.style.top = Math.round(r.bottom + 8) + 'px';
      panel.style.width = 'auto';
      panel.style.maxWidth = 'none';
    } else {
      panel.style.position = '';
      panel.style.left = '';
      panel.style.right = '';
      panel.style.top = '';
      panel.style.width = '';
      panel.style.maxWidth = '';
    }
  }

  function show() {
    clearTimeout(closeTimer);
    if (open) return;
    open = true;
    place();
    panel.hidden = false;
    icon.setAttribute('aria-expanded', 'true');
    refresh();
  }

  window.addEventListener('resize', function () { if (open) place(); }, { passive: true });

  function hide() {
    if (!open) return;
    open = false;
    panel.hidden = true;
    icon.setAttribute('aria-expanded', 'false');
  }

  function hideSoon() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(hide, 200);
  }

  /* click: open the panel instead of navigating (View cart button navigates).
     On hover-capable devices the approach hover has usually ALREADY opened it —
     the click must not toggle it straight back shut. Close = outside click,
     Escape, or mouse-leave. */
  icon.addEventListener('click', function (e) {
    e.preventDefault();
    if (open && !hoverable) { hide(); return; } // touch: tap toggles
    show();
  });

  /* hover intent on devices that support it */
  if (hoverable) {
    wrap.addEventListener('mouseenter', show);
    wrap.addEventListener('mouseleave', hideSoon);
  }

  /* dismiss: Escape, click outside, or focus leaving the widget */
  document.addEventListener('keydown', function (e) {
    if (e.defaultPrevented || e.key !== 'Escape' || !open) return;
    var restoreFocus = wrap.contains(document.activeElement);
    hide();
    if (restoreFocus) icon.focus();
  });
  document.addEventListener('click', function (e) {
    if (open && !wrap.contains(e.target)) hide();
  });
  wrap.addEventListener('focusout', function () {
    setTimeout(function () {
      // focus landing on <body> means it was DROPPED (e.g. the stepper button the
      // user clicked was replaced by a re-render) — not moved away. Stay open.
      var ae = document.activeElement;
      if (open && ae !== document.body && ae !== document.documentElement && !wrap.contains(ae)) hide();
    }, 0);
  });

  /* keep the open panel in sync when something is added (e.g. sticky ATC / PDP) */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'pmsteel-mini-cart') return; // our own change — already rendered
      if (open) refresh();
    });
  }
})();
